<template>
  <div>
    <HeadInfo />
    <Nav />
    <Diversityplot v-if="type === 'plot'" />
    <Stills v-if="type === 'still'" />
    <Casts v-if="type === 'cast'" />
    <like />
    <Gotop />
  </div>
</template>

<script>
import Gotop from '../common/components/Gotop.vue';
import pageExpose from '../common/mixins/pageExpose';
import Casts from './components/Casts.vue';
import Diversityplot from './components/Diversityplot.vue';
import HeadInfo from './components/HeadInfo.vue';
import Like from './components/Like.vue';
import Nav from './components/Nav.vue';
import Stills from './components/Stills.vue';

export default {
  components: {
    HeadInfo,
    Nav,
    Diversityplot,
    Stills,
    Casts,
    Like,
    Gotop,
  },
  mixins: [pageExpose],
  computed: {
    type() {
      return this.$route.params.type;
    },
  },
  asyncData({ context, store, route }) {
    return store
      .dispatch('summary/prefetchData', { context, route })
      .catch(err => console.log('[DETAIL_MOVIE_PREFETCH_ERROR]', err));
  },
  methods: {
    getResizePicUrl(url, width, height, appid) {
      // 获取云图裁剪图片地址
      if (url === null || url === '') return '';
      const r = Math.floor(Math.random() * 4) + 1;
      let newurl = '';
      newurl = `https://img0${r}.sogoucdn.com/v2/thumb/resize/w/${width}/h/${height}/t/1/retype/ext/auto/q/75?appid=${appid}&url=${encodeURIComponent(url)}`;
      return newurl;
    },
  },
};
</script>
